var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M991 536L991 564",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 991.5,
    cy: 531.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.83 528.888L992.354 525.027C992.278 524.991 992.202 524.991 992.126 525.027L981.651 528.888C981.651 528.888 981.651 528.888 981.632 528.888C981.613 528.888 981.613 528.906 981.594 528.906C981.594 528.906 981.575 528.906 981.575 528.923C981.556 528.923 981.556 528.941 981.537 528.941C981.537 528.941 981.537 528.941 981.518 528.959C981.499 528.976 981.499 528.976 981.48 528.994C981.48 529.012 981.461 529.012 981.461 529.03V529.047C981.461 529.065 981.461 529.065 981.442 529.083V529.1C981.442 529.118 981.442 529.136 981.442 529.154V533.741C980.626 533.883 980 534.556 980 535.353C980 536.256 980.797 537 981.765 537C982.733 537 983.53 536.256 983.53 535.353C983.53 534.538 982.903 533.883 982.087 533.741V529.579L984.118 530.323V533.387C984.118 534.272 984.991 535.087 986.604 535.689C988.122 536.238 990.115 536.557 992.24 536.557C994.366 536.557 996.377 536.256 997.876 535.689C999.47 535.105 1000.36 534.29 1000.36 533.387V530.323L1002.81 529.419C1002.92 529.384 1003 529.277 1003 529.154C1003 529.03 1002.94 528.941 1002.83 528.888ZM982.922 535.353C982.922 535.937 982.41 536.415 981.784 536.415C981.158 536.415 980.645 535.937 980.645 535.353C980.645 534.768 981.158 534.29 981.784 534.29C982.41 534.29 982.922 534.768 982.922 535.353ZM999.755 533.404C999.755 534.662 996.738 535.99 992.24 535.99C987.743 535.99 984.725 534.644 984.725 533.404V530.553L992.126 533.28C992.164 533.298 992.202 533.298 992.24 533.298C992.278 533.298 992.316 533.298 992.354 533.28L999.755 530.553V533.404ZM999.945 529.88L992.24 532.714L984.535 529.862L982.6 529.154L992.24 525.593L1001.88 529.154L999.945 529.88Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool3);
export default __webpack_public_path__ + "static/media/school_3.b9d2a5ebe33438522e29c10da91a00bf.svg";
export { ForwardRef as ReactComponent };